import Container from './AdoptabobblesBoughtBox.container';
import AdoptabobblesBoughtBox from './AdoptabobblesBoughtBox';

export default Container(AdoptabobblesBoughtBox);
